import { render, staticRenderFns } from "./villageApply.vue?vue&type=template&id=35476912&scoped=true&"
import script from "./villageApply.vue?vue&type=script&lang=js&"
export * from "./villageApply.vue?vue&type=script&lang=js&"
import style0 from "./villageApply.vue?vue&type=style&index=0&id=35476912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35476912",
  null
  
)

export default component.exports